<template>
  <div>
    <input type="file" ref="file" style="display: none" @change="sendFile" />
    <editor
      readonly
      :disabled="disabled"
      @input="$emit('input', $event)"
      ref="editor"
      :init="init"
      :value="value"
    >
    </editor>
  </div>
</template>
<script>
import tinymce from 'tinymce/tinymce'
import { Attachment } from '@/api'
// skins
import 'tinymce/skins/ui/oxide/skin.min.css'
// plugins
import 'tinymce/themes/silver'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/link'
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/image'
import 'tinymce/plugins/autoresize'
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/colorpicker'
import 'tinymce/plugins/imagetools'
import 'tinymce/plugins/media'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/code'

export default {
  props: {
    value: { type: String },
    simple: { type: Boolean },
    useBr: { type: Boolean },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false }
  },
  data() {
    return {
      callback: () => {},
      readonlyEditorInit: {
        menubar: false,
        plugins: '',
        toolbar: ''
      },
      simpleEditorInit: {
        menubar: false,
        plugins:
          'advlist image autoresize imagetools textcolor colorpicker paste media link code',
        toolbar: 'bold italic backcolor forecolor | link code',
        file_picker_callback: this.filePickerCallback
      },
      noToolbarEditorInit: {
        menubar: false,
        plugins:
          'advlist image autoresize imagetools textcolor colorpicker paste media link code',
        toolbar: '',
        file_picker_callback: this.filePickerCallback
      },
      editorInit: {
        menubar: false,
        image_advtab: true,
        extended_valid_elements:
          'svg[*],defs[*],pattern[*],desc[*],metadata[*],g[*],mask[*],path[*],line[*],marker[*],rect[*],circle[*],ellipse[*],polygon[*],polyline[*],linearGradient[*],radialGradient[*],stop[*],image[*],view[*],text[*],textPath[*],title[*],tspan[*],glyph[*],symbol[*],switch[*],use[*]',
        plugins:
          'advlist image autoresize imagetools paste media link lists code',
        toolbar:
          'undo redo | aligncenter alignright | forecolor | italic bold superscript | bullist numlist | code | shy',
        setup: editor => {
          editor.ui.registry.addButton('shy', {
            text: 'Soft hyphen',
            onAction: () => {
              editor.insertContent(
                '<img style="background: red; width: 0.65em; margin-bottom: 0.175em; height: 2px;">'
              )
            }
          })
        },
        content_css: '/static/wyswig.css',
        advlist_bullet_styles: 'default',
        paste_data_images: true,
        file_picker_callback: this.filePickerCallback
      }
    }
  },
  watch: {
    value(value) {
      if (value === undefined) {
        this.$emit('input', '')
      }
    }
  },
  computed: {
    init() {
      let editorInit = this.editorInit
      if (this.simple) {
        editorInit = this.simpleEditorInit
      }
      if (this.useBr) {
        editorInit.forced_root_block = false
      }
      if (this.readonly) {
        editorInit = this.readonlyEditorInit
      }
      return editorInit
    }
  },
  methods: {
    filePickerCallback(callback, value, meta) {
      this.callback = callback
      this.$refs.file.click()
    },
    sendFile(event) {
      const file = event.target.files[0]
      const data = new FormData()
      data.append('file', file, file.name)
      return Attachment.upload(data)
        .then(response => {
          this.callback(response.data.file, { text: file.name })
        })
        .catch(this.uploadError)
    },
    uploadError(error) {
      console.error(error, 'error while file uploading')
      this.$message({
        message: 'Error occurred while file uploading.',
        type: 'error'
      })
    }
  }
}
</script>
<style>
.tox {
  z-index: 3000;
}
</style>
